var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.stock-bad'),"name":"warehouseStocksRefused","url":_vm.$listRoutes.warehouseStocks.replace(':stage', 'refused'),"table":_vm.warehouseStocksRefused,"filters":_vm.warehouseStocksRefusedFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }